import React, { ReactNode } from 'react';

import Field from 'components/Form/Field';
import RadioButtons from 'components/Radio/RadioButtons';

type Props = {
  'data-qa-id'?: string;
  name: string;
  label?: ReactNode;
  disabled?: boolean;
  description?: ReactNode;
  buttons: Array<{
    label: ReactNode;
    value: string | boolean | number;
    disabled?: boolean;
  }>;
  large?: boolean;
  square?: boolean;
  onChange?: (
    arg0:
      | (string | null | undefined)
      | (boolean | null | undefined)
      | (number | null | undefined)
  ) => void;
  alignTop?: boolean;
  columns?: 1 | 2 | Array<number>;
  canDeselect?: boolean;
  value?: string | boolean | number;
  onUpdateValue?: (arg0: unknown) => void;
};

export function RadioButtonsField({
  name,
  label,
  description,
  buttons,
  large,
  alignTop,
  columns,
  canDeselect,
  ...props
}: Props) {
  return (
    <Field
      inputProps={props}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, id, qaId, hasError, updateValue }) => {
        const update = (v) => {
          updateValue(v);

          if (props.onUpdateValue) {
            props.onUpdateValue(v);
          }
        };

        return (
          <RadioButtons
            id={id}
            name={name}
            value={value}
            buttons={buttons}
            large={large}
            alignTop={alignTop}
            hasError={hasError}
            onChange={update}
            canDeselect={canDeselect}
            data-qa-id={qaId}
            columns={columns}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        );
      }}
    />
  );
}
